import './ScrollToTop.scss';

import Button from '@components/Button';
import { useFilterSettings } from '@providers/FilterProvider';
import { createClsNameMap, mapModifiers } from '@utils';
import { debounce } from 'lodash-es';
import { useEffect, useState } from 'react';

const clsNameMap = createClsNameMap({
  modifiers: ['black', 'grey'],
})(`scroll-to-top`);

const ScrollToTop = () => {
  const { activeScrollToTop, styleScrollToTop } = useFilterSettings();

  const [isScrollToTop, setIsScrollToTop] = useState<boolean>(false);

  const scrollOnTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    const debounceScrollPage = debounce(() => {
      if (window.scrollY > 100) {
        !isScrollToTop && setIsScrollToTop(true);
      } else {
        setIsScrollToTop(false);
      }
    }, 50);

    activeScrollToTop && window.addEventListener('scroll', debounceScrollPage);
  }, []);

  if (!isScrollToTop) return <></>;

  return (
    <Button
      className={mapModifiers(clsNameMap, [styleScrollToTop === 'style2' ? 'grey' : 'black'])}
      aria-label={'Back to top'}
      onClick={scrollOnTop}
      style={{
        visibility: 'visible',
      }}
    />
  );
};

export default ScrollToTop;
